import React, {Component} from 'react';
import './trafficCard.css';
import {Col, Row} from "antd";
// 引入 ECharts 主模块(这里路径引入错误参考上文文档描述)
import echarts from 'echarts/lib/echarts';

// 引入柱状图（这里放你需要使用的echarts类型 很重要）
import 'echarts/lib/chart/bar';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import {getTrafficCount,getYearTrafficGraph} from "../actions";

class TrafficCard extends Component {

    constructor(props) {
        super(props);
        this.state={
            yearTraffiCount:0,
            weekTraffiCount:0,
            dayTraffiCount:0,
            xcolumn:[],
            ynumber:[]
        }
        this.resize = this.resize.bind(this);
    }

    state = {
        width: 0,
        myChart: null
    }


    screenChange() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        console.info("componentWillUnmount");
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.state.myChart.resize();
    }

    componentDidMount() {
        this.screenChange();
        // 基于准备好的dom，初始化echarts实例
        this.setState({
            myChart: echarts.init(document.getElementById('trafficCardGraph'))
        })


        //获取访问量数据量（近一年， 一月，一周）
        getTrafficCount("year", this.updateYearData.bind(this))

        //获取近一年的访问量的折现图
        getYearTrafficGraph(this.updateYearTrafficGraph.bind(this))

        setTimeout(()=>this.resize(), 1)
    }

    updateYearData(totalData){
        this.setState({
            yearTraffiCount:totalData.total,
            weekTraffiCount:totalData.week,
            dayTraffiCount:totalData.day
        })
    }

    updateYearTrafficGraph(dayPostCount) {
        let tilte=[];
        let numbers=[];
        dayPostCount.map((el)=>{
            tilte.push(el.time);
            numbers.push(el.count);
        });
        this.setState({xcolumn:tilte,ynumber:numbers})
    }



    render() {
        let itemStyle={
            normal: {
                // opacity: 0.8,
                // shadowBlur: 10,
                // shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowColor: '#3398DB'
            }
        };

        // 绘制图表
        if (this.state.myChart) {
            this.state.myChart.setOption({
                backgroundColor: '#F5F8FD',
                height:240,
                color: ['#3398DB'],
                title: {
                    text: '近一年用户访问量',
                    left:28,
                    top:23,
                    textStyle: {
                        fontSize: '12',
                        fontFamily: 'Microsoft YaHei'
                    }
                },
                dataZoom: [{
                    type: 'inside',
                    throttle: 50
                }],
                tooltip: {},
                xAxis: {
                    data: this.state.xcolumn,
                    axisTick: {show: false},
                    axisLabel:{interval:0, rotate:45,margin:10},
                    type : 'category',
                    boundaryGap: false,
                },
                grid: {
                    left: '35',
                    right: '35',
                    bottom: '0',
                    containLabel: true
                },
                yAxis: {
                    axisTick: {show: false},
                },
                series: [{
                    itemStyle: itemStyle,
                    name: '用户访问量',
                    type: 'line',
                    barCategoryGap: '40%',
                    smooth: false,
                    // symbol: 'circle',
                    symbolSize: 5,
                    sampling: 'average',
                    data: this.state.ynumber,
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#D1E7FC'
                            }, {
                                offset: 1,
                                color: '#EEF5FC'
                            }])
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'top'
                        }
                    },
                }],
            });
        }

        return <div className='trafficCard'>
            <Row>
                <Col span={5} xs={5} md={5} xxl={5}>
                    <div className="trafficCardLeft ">
                        <div className='cardTitle'>用户访问量</div>
                        <AccessCard title={'近一年访问量'} number={this.state.yearTraffiCount} color={'#FE5B00'} image={'url(images/left01.png)'}></AccessCard>
                        <AccessCard title={'本周访问量'} number={this.state.weekTraffiCount} color={'#393F45'} image={'url(images/left02.png)'}></AccessCard>
                        <AccessCard title={'今日访问量'} number={this.state.dayTraffiCount} color={'#393F45'} image={'url(images/left03.png)'}></AccessCard>
                    </div>
                </Col>
                <Col span={19} xs={19} md={19} xxl={19}>
                    <div   ref={"area"}>
                        <div className='trafficCardGraph' id="trafficCardGraph" style={{width: '100%',maxWidth:712, height: 315}}>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    }
}

class AccessCard extends Component {

    constructor(props) {
        super(props);
        this.state={
           image:props.image,
            color:props.color
        }
    }

    render() {
        let stylet = {
            backgroundImage: this.state.image,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        }

        let numberStyle={
            color:this.state.color
        }
        return <div className='accessCard'>
            <Row>
                <Col span={8} xs={8} md={8} xxl={8}>
                    <div className='accessImage access' style={stylet}></div>
                </Col>
                <Col span={16} xs={16} md={16} xxl={16}>
                    <div className="titleNumber">
                        <div className='title'>{this.props.title}</div>
                        <div className='number' style={numberStyle}>{this.props.number}</div>
                    </div>
                </Col>
            </Row>
        </div>
    }
}

export default TrafficCard;
